import {
  EnumOrderPostStatus,
  EnumOrderStatus,
  EnumProductVersion,
  IAddressViewModel,
  IDeliveryAddressViewModel,
} from 'Interfaces/IGlobalTypeConfig';
import {
  IOrderAddViewModel,
  IOrderCompanyViewModel,
  IOrderContactViewModel,
  IOrderPostSimpleViewModel,
  IOrderPostViewModel,
} from 'Interfaces/IOrderConfig';
import { iProductSimpleViewModel } from 'Interfaces/IProductConfig';
import _ from 'lodash';
import dayjs from 'dayjs';
import { SingleOrderPostTicketViewModel } from '../ViewModels/OrderPostViewModels';

export function ConvertToOrderPostSimpleViewModel(
  orderPost: IOrderPostViewModel,
  prevProduct: iProductSimpleViewModel
): IOrderPostSimpleViewModel {
  console.log('convertToOrderPostSimpleViewModel', orderPost, prevProduct);
  return {
    orderPostId: prevProduct.orderPostId,
    orderNo: '', // Assuming this needs to be set separately if needed
    status: EnumOrderStatus.Ordered, // Map your status accordingly
    companyId: orderPost.companyId,
    orderedQuantity: prevProduct.orderedQuantity,
    ownerId: prevProduct.productOwner?.id ?? null,
    ticketId: prevProduct.ticketId,
    ticketProductId: prevProduct.ticketProductId,
    productId: prevProduct.productId,
    unitPrice: orderPost.unitPrice || 0,
    retailPrice: prevProduct.retailPrice || 0,
    quantity: prevProduct.originalQuantity || 0,
    deliveredQuantity: prevProduct.alreadyOrderedQuantity,
    serialNumber: '',
  };
}

export function CreateOrderAddViewModel(
  order: any,
  vendor: IOrderCompanyViewModel,
  deliveryAddress: IDeliveryAddressViewModel,
  responsibleId: string,
  orderCost: number,
  shippingCost: number
): IOrderAddViewModel {
  const orderPostsSimple: IOrderPostSimpleViewModel[] =
    order.orderPostsList.flatMap((orderPost: IOrderPostViewModel) =>
      orderPost.prevProducts.map((prevProduct: iProductSimpleViewModel) =>
        ConvertToOrderPostSimpleViewModel(orderPost, prevProduct)
      )
    );
  console.log('onSubmit- orderPostsSimple', orderPostsSimple);
  return {
    vendorId: vendor.id,
    orderCost: orderCost,
    shippingCost: shippingCost,
    orderPosts: orderPostsSimple,
    attention: deliveryAddress.attention ?? '',
    deliveryArea: deliveryAddress.area,
    deliveryCity: deliveryAddress.city,
    deliveryCountry: deliveryAddress.country,
    deliveryPostalCode: deliveryAddress.postalCode.toString(),
    deliveryStreet: deliveryAddress.street,
    deliveryPostBox: deliveryAddress.postBox ?? '',
    responsibleId,
  };
}

export const GenerateAddressList = (
  owner: any,
  companyDeliveryAddress: IAddressViewModel | null,
  employee: IOrderContactViewModel | null,
  addressList: IDeliveryAddressViewModel[]
): IDeliveryAddressViewModel[] => {
  console.log('tmp 1', addressList);
  let tmp: IDeliveryAddressViewModel[] = _.cloneDeep(addressList);
  console.log('tmp 2', tmp, owner);

  if (owner != null) {
    tmp[0].addressId = owner.deliveryAddress.id;
    tmp[0].street = owner.deliveryAddress.street;
    tmp[0].postalCode = owner.deliveryAddress.postalCode.toString() ?? '';
    tmp[0].area = owner.deliveryAddress.area;
    tmp[0].city = owner.deliveryAddress.city;
    tmp[0].country = owner.deliveryAddress.country;
    tmp[0].postBox = owner.deliveryAddress.postBox ?? '';
    tmp[0].attention = addressList[0].attention ?? '';
  }

  console.log('tmp 3', tmp);

  if (companyDeliveryAddress != null) {
    if (
      companyDeliveryAddress.street !== addressList[1].street &&
      addressList[1].street !== ''
    ) {
    } else {
      tmp[1].addressId = companyDeliveryAddress.id ?? '';
      tmp[1].street = companyDeliveryAddress.street ?? '';
      tmp[1].postalCode = companyDeliveryAddress.postalCode.toString() ?? '';
      tmp[1].area = companyDeliveryAddress.area ?? '';
      tmp[1].city = companyDeliveryAddress.city ?? '';
      tmp[1].country = companyDeliveryAddress.country ?? '';
      tmp[1].postBox = companyDeliveryAddress.postBox ?? '';
      tmp[1].attention = addressList[1].attention ?? '';
    }
  }

  console.log('tmp 4', tmp);

  if (employee != null && employee.departmentAddress != null) {
    if (
      employee.departmentAddress.street !== addressList[2].street &&
      addressList[2].street !== ''
    ) {
    } else {
      tmp[2].addressId = employee.departmentAddress.id;
      tmp[2].street = employee.departmentAddress.street;
      tmp[2].postalCode = employee.departmentAddress.postalCode.toString();
      tmp[2].area = employee.departmentAddress.area;
      tmp[2].city = employee.departmentAddress.city;
      tmp[2].country = employee.departmentAddress.country;
      tmp[2].postBox = employee.departmentAddress.postBox ?? '';
      tmp[2].attention = addressList[2].attention ?? '';
    }
  }

  console.log('tmp 5', tmp);

  if (
    (employee != null &&
      employee.homeAddress != null &&
      addressList[3].addressId === null) ||
    (employee != null &&
      employee.homeAddress != null &&
      addressList[3].addressId === employee.homeAddress.id)
  ) {
    tmp[3].addressId = employee.homeAddress.id;
    tmp[3].street = employee.homeAddress.street;
    tmp[3].postalCode = employee.homeAddress.postalCode.toString();
    tmp[3].area = employee.homeAddress.area;
    tmp[3].city = employee.homeAddress.city;
    tmp[3].country = employee.homeAddress.country;
    tmp[3].postBox = employee.homeAddress.postBox ?? '';
    tmp[3].attention = addressList[3].attention ?? '';
  }

  console.log('tmp 6', tmp);

  tmp[4].addressId = addressList[4].id ?? '';
  tmp[4].street = addressList[4].street ?? '';
  tmp[4].postalCode = addressList[4].postalCode ?? '';
  tmp[4].area = addressList[4].area ?? '';
  tmp[4].city = addressList[4].city ?? '';
  tmp[4].country = addressList[4].country ?? '';
  tmp[4].postBox = addressList[4].postBox ?? '';
  tmp[4].attention = addressList[4].attention ?? '';

  console.log('tmp 7', tmp);

  return tmp;
};

export const ConvertFromIOrderTicket = (
  ticketId: string,
  companyId: string,
  obj: iProductSimpleViewModel
) => {
  return {
    id: obj.id,
    orderPostId: obj.orderPostId,
    status: EnumOrderPostStatus.Ordered,
    deliveryDate: dayjs(new Date()).add(4, 'day'),
    companyId: companyId,
    company: null,
    companyContactId: null,
    companyContact: null,
    ticketId: ticketId,
    ticket: null,
    productId: obj.id,
    product: null,
    productVersion: EnumProductVersion.OrderProduct,
    ticketProductId: obj.id,
    ticketProduct: null,
    unitPrice: obj.unitPrice,
    retailPrice: obj.retailPrice,
    quantity: obj.originalQuantity - obj.alreadyOrderedQuantity,
    deliveredQuantity: 0,
    serialNumbers: [],
    isSerialNumber: false,
    originalQuantity: obj.originalQuantity,
    originalUnitPrice: obj.unitPrice,
    originalRetailPrice: obj.retailPrice,
    url: obj.url ?? '',
    responsibleId: '',
    prevOrderPostId: null,
    prevProducts: [obj],
  } as IOrderPostViewModel;
};

export const isSaveOrderButtonDisabled = (headerOrderListItem: any) => {
  let isDisabled = true;
  if (
    !!headerOrderListItem.orderState.vendor?.id &&
    !!headerOrderListItem.orderState.deliveryAddress.street &&
    headerOrderListItem.orderState.orderPostsList.length > 0
  ) {
    isDisabled = false;
  }
  return isDisabled;
};
// Enkeltlinje som kan opprettes i backend
export type CreateOrderPostItem = {
  // Fra høyre/venstre side:
  ticketProductId: string; // = line.id (OrderPostProductViewModel.id)
  orderPostId: string; // = line.orderPostId hvis du har det
  ticketId: string; // = line.ticketId (har du den pr line – fint; hvis ikke: slå opp via venstre side)
  companyId: string; // = ticket.companyInfo.id
  companyContactId: string; // = ticket.contact.id
  vendorId: string | null; // = valgt vendor eller linjens vendor.id
  unitPrice: number; // = felles kostpris (group/unitPrice) eller line.unitPrice
  retailPrice: number; // = line.retailPrice
  quantity: number; // = line.quantity (behov)
  orderedQuantity: number; // = line.orderedQuantity (det vi bestiller)
  vendorProductUrl?: string; // = group.vendorProductUrl / line.vendorProductUrl
  deliveryDate?: string | null; // ISO (hvis du samler dette i UI)
  status: EnumOrderPostStatus; // som regel EnumOrderPostStatus.New ved opprettelse
};

// Hvis du vil sende mange på én request:
export type CreateOrderPostsRequest = {
  orderNo?: string | null; // hvis du støtter order head
  freightCost?: number | null; // frakt fra UI (state.orderPost.freightCost)
  vendorOrderNumber?: string | null; // bestillingsnummer fra UI (state.orderPost.vendorOrderNumber)
  vendorId?: string | null; // valgt vendor for bestillingen (header)
  responsibleId: string | null; // ansvarlig for bestillingen (header)
  items: CreateOrderPostItem[];
};
// valgfritt: respons
export type CreateOrderPostsResponse = {
  orderNo: string;
  createdCount: number;
  ids?: string[];
};

// Hjelper: indexér venstre side på ticketId for rask lookup
export function indexTicketsById(
  tickets: SingleOrderPostTicketViewModel[]
): Record<string, SingleOrderPostTicketViewModel> {
  const map: Record<string, SingleOrderPostTicketViewModel> = {};
  for (const t of tickets) map[t.ticketId] = t;
  return map;
}

// Hjelper: finn company/contact for en line via ticketId
export function getCompanyRefs(
  idx: Record<string, SingleOrderPostTicketViewModel>,
  ticketId: string
) {
  const ticket = idx[ticketId];
  return {
    companyId: ticket?.companyInfo?.id ?? '',
    companyContactId: ticket?.contact?.id ?? '',
  };
}
